<!--执行函数配置页面 by xiemin -->
<template>
  <div class="m-l-50 m-t-30" v-loading="isLoading">
    <common-config :id="id" :form="form" :inputList="inputList" :isDepended="false">
      <template slot="self-config">
        <el-form-item label="选择函数">
          <el-cascader
            expand-trigger="hover"
            :show-all-levels="false"
            :options="exec_funcs"
            :props="props"
            :value="[form.package_name, form.function_name]"
            placeholder="选择函数"
            @change="execFuncChange">
          </el-cascader>
        </el-form-item>
        <el-form-item label="传入参数配置" v-if="form.params">
          <el-table
            :data="form.params">
            <el-table-column
              prop="title"
              label="参数">
            </el-table-column>
            <el-table-column
              prop="type"
              label="类型">
              <template scope="scope">
                <el-select
                  v-model="scope.row.type">
                  <el-option
                    v-for="item in typeOptions"
                    :label="item.title"
                    :value="item.id"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="value"
              label="传入对应值"
              width="218">
              <template scope="scope">
                <el-input v-model="scope.row.value" placeholder="请输入内容" v-if="scope.row.type===10"></el-input>
                <el-select
                  v-model="scope.row.value"
                  v-else>
                  <el-option
                    v-for="option in funcFields"
                    :label="option.field + '(' + option.title + ')'"
                    :value="option.field"></el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-card class="exec-cards" v-if="form.function_name">
          <div slot="header"><span>超时处理</span></div>
          <div>
            <el-form-item label="超时时间">
              <el-input type="number" v-model="form.timeout.max_time" placeholder="超时时间（s）"></el-input>
            </el-form-item>
            <el-form-item label="处理方式">
              <el-checkbox-group v-model="form.timeout.handle_type">
                <el-checkbox label="10">返回提醒</el-checkbox>
                <el-checkbox label="20">记录日志</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="自定义内容">
              <el-input type="textarea" v-model="form.timeout.content"></el-input>
              <div>*即提醒的内容及记录日志的自定义内容</div>
            </el-form-item>
          </div>
        </el-card>
        <el-card class="exec-cards" v-if="form.function_name">
          <div slot="header"><span>报错处理</span></div>
          <div>
            <el-form-item label="处理方式">
              <el-checkbox-group v-model="form.error.handle_type">
                <el-checkbox label="10">返回提醒</el-checkbox>
                <el-checkbox label="20">记录日志</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="自定义内容">
              <el-input type="textarea" v-model="form.error.content"></el-input>
              <div>*即提醒的内容及记录日志的自定义内容</div>
            </el-form-item>
          </div>
        </el-card>
        <el-card class="exec-cards" v-if="form.function_name">
          <div slot="header"><span>正常处理</span></div>
          <div class="exec-deal-wrap" v-for="(sucCondition, index) in form.success">
            <el-table
              :data="sucCondition.params">
              <el-table-column
                prop="title"
                label="返回参数">
              </el-table-column>
              <el-table-column
                prop="type"
                label="类型">
                <template scope="scope">
                  <el-select
                    v-model="scope.row.type">
                    <el-option
                      v-for="item in rtTypeOptions"
                      :label="item.title"
                      :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="logic"
                label="逻辑">
                <template scope="scope">
                  <el-select
                    v-model="scope.row.logic">
                    <el-option
                      v-for="item in logicOption"
                      :label="item.title"
                      :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="value"
                label="传入对应值"
                width="218">
                <template scope="scope">
                  <el-input v-model="scope.row.value" placeholder="请输入内容" v-if="scope.row.type===10"></el-input>
                  <el-select
                    v-model="scope.row.value"
                    v-else>
                    <el-option
                      v-for="option in funcFields"
                      :label="option.field + '(' + option.title + ')'"
                      :value="option.field"></el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table>
            <el-form-item label="处理方式">
              <el-checkbox-group v-model="sucCondition.handle_type">
                <el-checkbox label="10">返回提醒</el-checkbox>
                <el-checkbox label="20">记录日志</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="自定义内容">
              <el-input type="textarea" v-model="sucCondition.content"></el-input>
              <span>*即提醒的内容及记录日志的自定义内容</span>
              <el-button style="float: right; margin-top: 15px" size="small" @click="delReturnDeal(index)">删除</el-button>
            </el-form-item>
          </div>
          <div class="m-t-20 tx-c"><el-button type="primary" @click="addReturnDeal">添加返回值处理条件</el-button></div>
        </el-card>
      </template>
    </common-config>
  </div>
</template>
<style scoped>
  .exec-cards {
    margin-top: 22px;
  }
  .exec-deal-wrap {
    padding: 20px;
    margin-top: 20px;
    border: 1px solid #d1dbe5;
  }
</style>
<script>
  import http from '../../../../assets/js/http'
  import flowConfig from '../../../../config/flowConfig'
  import commonConfig from './commonConfig'
  import inputMixins from './inputMixins' // 页面布局相关方法
  export default {
    name: 'execConfig',
    data() {
      return {
        isLoading: false,
        id: 0,
        contentId: '',
        modelId: '',
        props: {
          label: 'title',
          value: 'name',
          children: 'functions'
        },
        form: {
          name: '',  // 操作名
          rule_name: '', // 权限标识
          model_name: '',  // 所选模型
          package_name: '', // 函数包名称
          function_name: '', // 函数名称
          params: [], // 传入参数配置
          field: [], // 所选控件
          is_depend: 0,
          depend_config: [], // 从属限制
          timeout: {
            max_time: null, // 超时时间
            handle_type: [],
            content: ''
          }, // 超时处理
          error: {
            handle_type: [],
            content: ''
          }, // 错误处理
          success: [] // 正常处理
        },
        typeOptions: [ // 参数类型列表
          { id: 10, title: '常量' },
          { id: 20, title: '变量' }
        ],
        rtTypeOptions: [ // 返回的参数类型列表
          { id: 10, title: '常量' },
          { id: 20, title: '变量' },
          { id: 30, title: '忽略' }
        ],
        sel_params: [], // 选中的函数对应的参数
        return_params: null, // 返回参数列表
        logicOption: [
          { id: '=', title: '等于' },
          { id: '!=', title: '不等于' },
          { id: '>', title: '大于' },
          { id: '<', title: '小于' },
          { id: '<=', title: '小于等于' },
          { id: '>=', title: '大于等于' },
          { id: '70', title: '包含' }
        ],
        funcPackage: {},
        funcFields: [], // 关联表单对应的字段
        exec_funcs: [], // 执行函数列表
        deleteShow: false  // 删除分组提示显示标识
      }
    },
    created() {
      this.id = parseInt(this.$route.params.id)
      this.contentId = parseInt(this.$route.params.contentId)
      this.getDetail()
      this.getFunctions()
    },
    methods: {
      getDetail() {
        this.isLoading = true
        this.apiGet(`cms/deals/${this.id}`).then((res) => {
          if (res.code == 200) {
            this.form.name = res.data.content_name
            this.form.rule_name = res.data.rule_name
            this.form.model_name = res.data.model_name
            if (res.data.config) {
              this.form.field = res.data.config.field
              this.form.is_depend = res.data.config.is_depend
              this.form.params = res.data.config.params
              this.form.success = res.data.config.success || this.form.success
              this.form.error = res.data.config.error || this.form.error
              this.form.timeout = res.data.config.timeout || this.form.timeout
              this.form.package_name = res.data.config.package_name
              this.form.function_name = res.data.config.function_name
              if (res.data.config.depend_config) {
                this.form.depend_config = res.data.config.depend_config
              }
            }
            this.modelId = res.data.model_id
            this.getFoncFields()
            this.getInputList()
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      },
      /**
       * 获取关联表单对应的字段
       */
      getFoncFields() {
        this.isLoading = true
        this.apiGet(`cms/deals/fields/${this.modelId}`).then((res) => {
          if (res.code == 200) {
            this.funcFields = res.data
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      },
      confirmCurField(inputs) { // 保存控件配置
        this.form.field = inputs
      },
      openDepentConfig() {
        this.$refs.depentConfig.openDialog()
      },
      /**
       * 获取执行函数列表
       */
      getFunctions() {
        this.isLoading = true
        this.apiGet('cms/contents/functions').then((res) => {
          if (res.code == 200) {
            _(res.data).forEach((ele) => {
              ele.name = ele.pakege_name
              delete ele.pakege_name
            })
            this.exec_funcs = res.data
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      },
      /**
       * 选择函数变化处理函数
       * @param  {Array}
       */
      execFuncChange(curValue) {
        this.form.function_name = curValue[curValue.length - 1]

        let parentIndex = _.findIndex(this.exec_funcs, (item) => {
          return item.name == curValue[0]
        })
        this.funcPackage = this.exec_funcs[parentIndex]

        let curIndex = _.findIndex(this.funcPackage.functions, (item) => {
          return item.name == curValue[curValue.length - 1]
        })

        this.form.package_name = this.funcPackage.name
        this.form.params = []
        // 根据选中的函数名称获取对应的参数
        // this.form.params = this.funcPackage.functions[curIndex].param
        // 选中的函数对应的参数
        this.sel_params = this.funcPackage.functions[curIndex].param

        _(this.sel_params).forEach((item) => {
          this.form.params.push({
            name: item.name,
            title: item.title,
            type: 10, // 10:常量 20:变量
            value: null
          })
        })
        // 根据选中的函数名称获取对应的返回参数
        this.return_params = []
        _(this.funcPackage.functions[curIndex].return_param).forEach((item) => {
          this.return_params.push({
            name: item.name,
            title: item.title,
            type: 10, // 10:常量 20:变量
            logic: null, // 比较逻辑
            value: null
          })
        })
        this.form.success = []
        this.form.timeout = {
          max_time: null, // 超时时间
          handle_type: [],
          content: ''
        }
        this.addReturnDeal()
      },
      /**
       * 添加返回值处理条件
       */
      addReturnDeal() {
        let index = this.form.success.length - 1
        let params = this.return_params || this.form.success[index].params
        this.form.success.push({
          handle_type: [],
          content: '',
          params: JSON.parse(JSON.stringify(params))
        })
      },
      /**
       * 删除正常处理条件
       * @param  {正常处理条件的索引}
       */
      delReturnDeal(index) {
        this.form.success.splice(index, 1)
      }
    },
    computed: {
      showCondition() {
        return this.form.has_condition == 1
      }
    },
    components: {
      commonConfig
    },
    mixins: [http, flowConfig, inputMixins]
  }
</script>


// WEBPACK FOOTER //
// execConfig.vue?09f5db78